import React from 'react';
import {
  RULE_CATEGORY_BUSINESS,
  RULE_CATEGORY_OPTIONS,
  RULE_CATEGORY_VIOLATION,
} from '../../../utils/businessMetrics';

/*
 * Категория правила в форме (BM-FE-TZ-002C) — первое и единственное
 * бизнес-поле формы: «Нарушение» по умолчанию или «Бизнес-метрика». Пока
 * backend не принимает категории (ruleCategorySupport), «Бизнес-метрика»
 * видна, но выключена с подсказкой: отправить такое правило всё равно было
 * бы нельзя.
 *
 * locked — категорию существующего правила меняет только администратор
 * (FE-16): остальные видят её, но переключить не могут.
 */

const SECTION_TITLES = {
  [RULE_CATEGORY_VIOLATION]: '«Нарушения»',
  [RULE_CATEGORY_BUSINESS]: '«Бизнес-метрики»',
};

/** ТЗ V5 №18: смена категории существующего правила переносит его историю. */
export const categoryTransferWarning = (category) => (
  `История правила и его события перейдут в раздел ${SECTION_TITLES[category] || '«Нарушения»'}. Номера правила и событий не изменятся.`
);

export const RuleCategoryField = ({
  value, onChange, supported, disabled = false, locked = false, error = '', idPrefix = 'vio', savedValue = null,
}) => (
  <fieldset className="vio-rule-category">
    <legend className="vio-drawer-section-title">Категория</legend>
    {RULE_CATEGORY_OPTIONS.map((option) => {
      const unavailable = option.value === RULE_CATEGORY_BUSINESS && !supported;
      return (
        <label className="vio-zone-scope-option" key={option.value}>
          <input
            type="radio"
            name={`${idPrefix}-category`}
            value={option.value}
            checked={value === option.value}
            disabled={disabled || locked || unavailable}
            onChange={() => onChange(option.value)}
          />
          <span>
            <strong>{option.label}</strong>
            {unavailable && (
              <span className="vio-field-hint">
                Станет доступно, когда система начнёт собирать бизнес-метрики.
              </span>
            )}
          </span>
        </label>
      );
    })}
    {locked && <p className="vio-field-hint">Категорию правила меняет администратор.</p>}
    {savedValue != null && savedValue !== value && !locked && (
      <p className="vio-category-transfer" role="status">{categoryTransferWarning(value)}</p>
    )}
    {error && <p className="vio-field-error">{error}</p>}
  </fieldset>
);
